import React from "react";
import { Sequence } from "../Sequence";
import { Dot } from "./Dot";
import { Explosion } from "./Explosion";
import { Shrinking } from "./Shrinking";
import { Trail } from "./Trail";
 
export const Dots = () => {
  return (
    <Explosion>
      <Trail amount={4} extraOffset = {0}>
        <Shrinking>
          <Sequence from={5}>
            <Dot />
          </Sequence>
        </Shrinking>
      </Trail>
    </Explosion>
  );
};